import { CustomerId, UnitGroupId } from '@reshub/model';
export class UnitGroupDto {
  id: UnitGroupId;
  customerId: CustomerId;
  name: string;
  description?: string;
}
